import React, { useEffect, useState } from "react";
import { Link } from "~/components/Elements";
import { FacebookEmbed, InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';
import "./AgregatorSocSieti.css";
const urlMoreInfo = "/agregator-soc-sieti";
import iconSearch from "./img/ass/icon-search-light.png";
import logoFb from "./img/ass/facebook.png";
import logoIg from "./img/ass/instagram.png";
import logoTiktok from "./img/ass/tiktok.png";
import logoSoundcloud from "./img/ass/icon-sc.svg";
import logoSpotify from "./img/ass/spotify.png";
import logoYt from "./img/ass/youtube.png";

const terazAgregatorSocSietiUrl = "/agregator-soc-sieti?vyhladat=true";

const HeaderBanner = (props) => {
  
  const [activeTab, setActiveTab] = useState('latest');  
  const [socialData, setSocialData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [embeddedFbPost, setEmbeddedFbPost] = useState('');
  const [embeddedIgPost, setEmbeddedIgPost] = useState('');
  const [embeddedYtPost, setEmbeddedYtPost] = useState('');
  const [embeddedSpotifyPost, setEmbeddedSpotifyPost] = useState('');
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://www.teraz.sk/api/social_network_content/list.php");
        const data = await response.json();
        setSocialData(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
        if (process.env.BUILD_TARGET !== "server") {
            const innerDiv = document.querySelector('.inner') as HTMLElement;   
            if (innerDiv) {
                innerDiv.style.marginTop = `${window.scrollY}px`;
            }
            const infoPopupDiv = document.querySelector('.info-popup') as HTMLElement;
            if (infoPopupDiv) {
              infoPopupDiv.style.marginTop = `${window.scrollY}px`;
            }
        }
    };
    const handleKeyUp = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            closePopup();
            setShowInfoPopup(false);
        }          
    };       

    if (process.env.BUILD_TARGET !== "server") {
        window.addEventListener('keyup', handleKeyUp);
        window.addEventListener('scroll', handleScroll);
    }
    return () => {
        if (process.env.BUILD_TARGET !== "server") {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('keyup', handleKeyUp);
        }
    };
   
}, []);



  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Format time as H:i
    const timeString = date.toLocaleTimeString('sk-SK', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });

    if (date.toDateString() === today.toDateString()) {
        return `dnes ${timeString}`;
    } else if (date.toDateString() === yesterday.toDateString()) {
        return `včera ${timeString}`;
    } else {
        return date.toLocaleString('sk-SK', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    }
};


function openEmbedPopup(url: string, networkType: string): void {    
    console.log(url, networkType);
    switch (networkType) {
        case 'FACEBOOK':
            setEmbeddedFbPost(url);
            break;
        case 'INSTAGRAM':
            setEmbeddedIgPost(url);
            break;
        case 'YOUTUBE':
            setEmbeddedYtPost(url);
            break;
        case 'SPOTIFY':
            setEmbeddedSpotifyPost(url);
            break;
        default:
            break;
    }
    setShowPopup(true);
    if (process.env.BUILD_TARGET !== "server") {
        const innerDiv = document.querySelector('.inner') as HTMLElement;
        if (innerDiv) {
            innerDiv.style.marginTop = `${window.scrollY}px`;
        }
    }
}



function closePopup(): void {        
    setEmbeddedFbPost('');
    setEmbeddedIgPost('');
    setEmbeddedYtPost('');
    setEmbeddedSpotifyPost('');
    setShowPopup(false);
}


function handleInfoPopup(): void {
    setShowInfoPopup(true);
    if (process.env.BUILD_TARGET !== "server") {
      const infoPopupDiv = document.querySelector('.info-popup') as HTMLElement;
      if (infoPopupDiv) {
        infoPopupDiv.style.marginTop = `${window.scrollY}px`;
      }
    }
}

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
<>
  {showPopup && (process.env.BUILD_TARGET !== "server") &&
      <div className={"embedded-post-popup " + (embeddedFbPost && 'fb-post')}>
          <div className="inner" style={{ marginTop: `${window.scrollY}px` }}>
              <div className="close-popup" onClick={() => closePopup()}>Zavrieť</div>
              {embeddedFbPost && (
                        <FacebookEmbed
                            url={embeddedFbPost}
                            width={window.innerWidth <= 600 ? '100%' : 750}
                            frame={window}
                        />
                    )}
              {embeddedIgPost && <InstagramEmbed url={embeddedIgPost} width={450}  />}
              {embeddedYtPost && <YouTubeEmbed url={embeddedYtPost} width={500} />}
          </div>                  
      </div>
      }

    {showInfoPopup && (process.env.BUILD_TARGET !== "server") && (
      <div className="info-popup" style={{ marginTop: `${window.scrollY}px` }}>
        <div className="close-popup" onClick={() => setShowInfoPopup(false)}>Zavrieť</div>
        <div className="info-popup-content">
          <p>Agregátor sociálnych sietí Politika na sociálnych sieťach je produkt TASR, ktorý vám umožní na jednom mieste sledovať najnovšie výstupy slovenských politických aktérov na troch sociálnych sieťach súčasne. Na jednej webovej stránke môžete scrollovať v rebríčku najsledovanejších Youtube videí za 30 dní a súčasne mať pred sebou zoznam najnovších videí tejto platformy v chronologickom poradí. Uvidíte najnovšie statusy slovenských politikov na Facebooku a Instagrame a súčasne facebookové statusy kľúčových štátnych inštitúcií. Zoznam agregovaných FB stránok a Youtube kanálov zostavil TASR z verejne prístupných stránok relevantných politických aktérov, zahŕňa stránky prezidenta, parlamentu, vlády, kľúčových štátnych inštitúcií, poslancov Národnej rady SR a poslancov Európskeho parlamentu, parlamentných politických strán, ako aj stránky mimoparlamentných politických strán, ktoré v prieskumoch dosahujú opakovane viac ako dve percentá a stránky ich predsedov. Pripojenie instagramových stránok  naviac prebieha schvaľovacou procedúrou zo strany agregovaných stránok, takže budú v agregátore pribúdať postupne na základe toho, kedy stránka s pripojením vysloví súhlas.</p>
        </div>
      </div>
    )}

    <div className="bannerBase ass-fullWidth">
      <div className="bannerTop">
        <div className="title">Politika na sociálnych sieťach</div>
        <ul className="socials-list">
          <li>
            <img src={logoFb} alt="Facebook"></img>
          </li>
          <li>
            <img src={logoIg} alt="Instagram"></img>
          </li>
          {/* <li>
            <img src={logoTiktok} alt="Tik Tok"></img>
          </li> */}
          <li>
            <img src={logoYt} alt="Youtube"></img>
          </li>
          {/* <li>
            <img src={logoSpotify} alt="Spotify"></img>
          </li> */}
          {/* <li>
            <img className="opacity-30" src={logoSoundcloud} alt="Soundcloud"></img>
          </li> */}
        </ul>
        <div className="actions">
          
          <div onClick={() => handleInfoPopup()} className="bannerBase-ass-btn no-margin info-popup-btn">Info</div>

          <Link to={terazAgregatorSocSietiUrl}>
            <div className="bannerBase-ass-btn no-margin">
              <img src={iconSearch} width="15" alt="Search"></img>
            </div>
          </Link>

          <Link to={urlMoreInfo}>
            <div className="bannerBase-ass-btn no-margin">Zobraziť viac</div>
        </Link>
        </div>        
      </div>
      <div className="bannerBottom">
        <div className="bannerBottomLeft">
          <div className="tabMenu">
          <div
              className={`tabLink ${activeTab === 'latest' ? 'active' : ''}`}
              onClick={() => handleTabClick('latest')}
            >
              Najnovšie videá
            </div>
            <div
              className={`tabLink ${activeTab === 'view' ? 'active' : ''}`}
              onClick={() => handleTabClick('view')}
            >
              Najsledovanejšie videá
            </div>            
          </div>
          <div className="tabContent">
            {activeTab === 'latest' && (
              <div className="assBannerList">
                {socialData?.YOUTUBE?.by_date?.slice(0, 4).map((item, index) => (
                    <div className="assBannerItem" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                      <div
                        className="imgWrapper"
                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                      ></div>
                      <div className="text">
                        <div className="title xl">
                          {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                        </div>
                        <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle} | {item.views} zobrazení</div>                        
                      </div>                      
                    </div>
                ))}
              </div>
            )}
            {activeTab === 'view' && (
              <div className="assBannerList">
                {socialData?.YOUTUBE?.by_views?.slice(0, 4).map((item, index) => (
                    <div className="assBannerItem" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                      <div
                        className="imgWrapper"
                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                      ></div>
                      <div className="text">
                        <div className="title xl">
                          {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                        </div>
                        <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle} | {item.views} zobrazení</div>
                      </div>
                      
                    </div>
                ))}
              </div>
            )}            
          </div>
        </div>
        <div className="bannerBottomRight">
          <div className="subtitle">Najnovšie statusy štátnych inštitúcií</div>

          <div className="assBannerList">
            {socialData?.FACEBOOK?.STATE_INSTITUTION?.by_date?.slice(0, 1).map((item, index) => (
                <div className={'assBannerItem ' + item.network_type} onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                  <div
                    className="imgWrapper circle"
                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                  ></div>
                  <div className="text">
                    <div className="title">
                      {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                    </div>
                    {item.text_content && <div className="desc">
                      {item.text_content.length > 120
                        ? item.text_content.substring(0, 120) + '...'
                        : item.text_content}
                      </div>}
                      <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle}</div>
                  </div>
                </div>
            ))}
          </div>

          <div className="subtitle m-top-20">Najnovšie politické statusy</div>
          <div className="assBannerList">
            {socialData?.FACEBOOK?.POLITICAL_PARTY?.by_date?.slice(0, 2).map((item, index) => (
                <div className={'assBannerItem ' + item.network_type} onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                  <div
                    className="imgWrapper circle"
                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                  ></div>
                  <div className="text">
                    <div className="title">
                      {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                    </div>
                    {item.text_content && <div className="desc">
                      {item.text_content.length > 120
                        ? item.text_content.substring(0, 120) + '...'
                        : item.text_content}
                      </div>}
                      <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle}</div>
                  </div>
                </div>
            ))}
          </div>


        </div>
      </div>
    </div>
    </>
  );
};

export default HeaderBanner;
